import { defineStore } from "pinia";
import garantiaModel from "@/models/garantiaModel";

export const useGarantiaStore = defineStore("garantiaStore", {
  state: () => ({
    resumen: {
        saldo: 0,
        credito: 0,
        ofertado: 0,
        ofertas_realizadas: []
    },
    movimientosGarantias: {},
    nueva_garantia: {
      medio_pago_id: "",
      monto: "",
      fecha_operacion: null,
      moneda: "ARS",
      user_id: "",
      tipo_movimiento: "Ingreso",
      numero_referencia: "",
      documento: "",
      banco_billetera: "",
      cbu: "",
      comprobante: {
        archivo: null,
        entidad: "garantia",
        filename: null,
        hash: null,
        extension: null,
        tipo_archivo_id: 1,
      },
    },
    medios_de_pago: [],
    medios_pago_destino: [],
    monedas: [],
    errores: [],
  }),
  actions: {
    async obtenerResumenGarantia() {
      try {
        const data = await garantiaModel.obtenerResumenGarantia();
        const ars = data.find((item) => item.moneda === "ARS");
        Object.assign(this.resumen, ars);
        
      } catch (error) {
        return;
      }
    },
    async obtenerMisMovimientosGarantias(page = 1) {
      try {
        const data = await garantiaModel.obtenerMisMovimientosGarantias(page);
        this.movimientosGarantias = data;
        
      } catch (error) {
        return;
      }
    },
    async getMediosDePago() {
      const medios = await garantiaModel.getMediosDePago();
      this.medios_de_pago = medios;
    },
    async getMediosDePagoDestino() {
      const medios = await garantiaModel.getMediosDePagoDestino();
      this.medios_pago_destino = medios;
    },
    async getMonedas() {
      const monedas = await garantiaModel.getMonedas();
      this.monedas = monedas;
    },

    async agregarComprobante(filedata) {
      this.nueva_garantia.comprobante.archivo = filedata.file;
      this.nueva_garantia.comprobante.extension = filedata.extension;
    },

    estructuraBaseGarantia() {
      return {
        medio_pago_id: "",
        monto: "",
        fecha_operacion: null,
        moneda: "ARS",
        user_id: "",
        tipo_movimiento: "Ingreso",
        numero_referencia: "",
        documento: "",
        cbu: "",
        comprobante: {
          archivo: null,
          entidad: "garantia",
          filename: null,
          hash: null,
          extension: null,
          tipo_archivo_id: 1,
        },
      };
    },

    async enviarGarantia() {
      try {
        this.errores = [];
        await garantiaModel.enviarGarantia(this.nueva_garantia);
        this.nueva_garantia = this.estructuraBaseGarantia();
        this.obtenerResumenGarantia();
        this.obtenerMisMovimientosGarantias();
      } catch (error) {
        console.log(error.response);
        this.errores.push(error.response.data);
      }
    },
    async pedirDevolucion(monto,moneda,cbuDevolucion) {
      const monedaDevolucion = moneda ?? 'ARS';
      await garantiaModel.pedirDevolucion(monto,monedaDevolucion,cbuDevolucion);
    },
  },
});
